import { Box, Typography } from "@mui/material";

import { useAtomValue } from "jotai";

import { isReferenceMeasurementModeActiveAtom } from "store/atoms/isReferenceMeasurementModeActive";

const REF_MSMNT_INFORMATION_BOX_TEXT =
  "This is an uncalibrated reconstruction. To calibrate, select two points and enter their real-world measurements. You can repeat this process several times to achieve greater calibration accuracy. <br /> <br /> Click this button to stop calibration and measure normally.";

export default function ReferenceMeasurementInformationBox() {
  const isReferenceMeasurementModeActive = useAtomValue(
    isReferenceMeasurementModeActiveAtom
  );

  if (!isReferenceMeasurementModeActive) return null;

  return (
    <Box
      sx={{
        width: "14rem",
        background: "#3335",
        backdropFilter: "blur(25px)",
        transformOrigin: "bottom",
        transform: "translateY(-70%)",
        padding: 1,
        borderRadius: 1.5,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontSize: ".6rem",
        }}
        dangerouslySetInnerHTML={{ __html: REF_MSMNT_INFORMATION_BOX_TEXT }}
      />
    </Box>
  );
}
